import { createFileRoute } from '@tanstack/react-router'
import { DreamPadPage } from '@/features/dreams/views'
import { Layout } from '@/shared/wrappers/Layout'
import { useTelegramDesktop } from '@/hooks/use-telegram-desktop'
import { cn } from '@/shared/lib/utils'
import { DreampadPlaceholder } from '@/features/dreams/views/dreampad-placeholder'

export const Route = createFileRoute('/dream-pad')({
  component: DreamPadRoot,
})

function DreamPadRoot() {
  const isDesktop = useTelegramDesktop()

  if (import.meta.env.VITE_DISABLE_DREAMS === '1') {
    return (
      <Layout
        className="relative select-none min-h-dvh!"
        safeX="no-safe"
        safeY="no-safe"
        nav={'nav'}
      >
        <DreampadPlaceholder />
      </Layout>
    )
  }

  return (
    <Layout
      nav={'nav'}
      safeX={'no-safe'}
      safeY={'no-safe'}
      className={cn(isDesktop ? 'pt-4' : 'pt-safe-area')}
    >
      <DreamPadPage />
    </Layout>
  )
}
